import { Component, ElementRef, ViewChild } from '@angular/core';
// import { CanvasComponent } from "src/canvas/canvas.component";
import { saveAs } from 'file-saver';

@Component({
  selector: 'ocrCvTblTable',
  templateUrl: './ocr-cv-tbl-table.component.html',
  styleUrls: ['./ocr-cv-tbl-table.component.css'],
})
export class OcrCvTblTableComponent {
  tableData;
  ocrCvTblData: any;
  showBtn = 'none';
  ocrCvTblItemOver;
  lastClickedWord: any;
  currentItemType: any;
  currentItem: any;
  lastTarget: any;
  popupPositionLeft: number = 0;
  popupPositionTop: number = 0;
  uid: string;
JSON: any;

  ngAfterViewInit() {}

  tablesObjToArray(tablesList: any) {
    var arr: any[] = [];
    for (let tables of tablesList) {
      for (let table of tables) {
        var rows: any[] = [];
        for (let rowOrig of table.table) {
          var row: any[] = [];
          for (let cell of rowOrig) {
            row.push(cell);
          }
          rows.push(row);
        }

        arr.push(rows);
      }
    }
    return arr;
  }
  displayTable(body: any) {
    this.showBtn = 'block';
    this.ocrCvTblData = body;
    this.uid = body.uid;

    this.tableData = this.tablesObjToArray(this.ocrCvTblData.tables);
    // this.tableData = this.ocrCvTblData.tables;
    console.log('this.tableData', this.tableData);
  }

  replacer(key, value) {
    return value === null ? '' : value.text.replace('"', "'"); // specify how you want to handle null values here
  }
  downloadAllCsv() {
    let csv = [];
    for (let table of this.ocrCvTblData.tables) {
      let csvTmp = table.rows.map((row) =>
        row.cells.map((cell) => JSON.stringify(cell, this.replacer)).join(',')
      );
      csv = csv.concat(csvTmp);
    }
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' });
    saveAs(blob, 'ocrCvTbl.csv');
  }

  downloadCsv(table, i) {
    let csv = table.map((row) =>
      row.map((cell) => JSON.stringify(cell, this.replacer)).join(',')
    );
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' });
    saveAs(blob, `ocrCvTbl-${i}.csv`);
  }

  itemFocusout() {}

  tableItemDown($event, type, item) {
    console.log($event);

    $event.currentTarget.style.backgroundColor = 'yellow';
    if (this.lastTarget && this.lastTarget != $event.currentTarget) {
      this.lastTarget.style.backgroundColor = 'white';
    }
    this.lastTarget = $event.currentTarget;
    this.currentItemType = item[type];
    this.currentItem = item;
  }

  wordClicked(word: any) {
    if (this.lastClickedWord == word) return;
    // console.log(word["description"]);
    this.lastClickedWord = word;
    setTimeout(() => {
      this.lastClickedWord = null;
    }, 1000);
    if (this.currentItemType) {
      this.currentItemType.word.text += ` ${word['description']}`;
    }
  }
  addRow() {
    this.tableData.unshift({
      label: { word: { text: '' } },
      value: { word: { text: '' } },
      chosen: true,
    });
  }
  restart() {
    // this.unchooseTr();
    this.tableData = null;
  }

  downloadImg() {
    const imgBase64 = `data:image/png;base64, ${this.tableData.imgBase64}`;
    const link = document.createElement('a');
    link.href = imgBase64;
    link.download = 'receipt.png';
    link.click();
  }
}
